import { render, staticRenderFns } from "./MotoristaRead.vue?vue&type=template&id=40e3c6b5&"
import script from "./MotoristaRead.vue?vue&type=script&lang=js&"
export * from "./MotoristaRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports